import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { ApplicationExceptionHandler } from '@project-management-system/backend-utils';
import { JobworkCreationEntity } from './entity/job-work-creation-entity';
import { JobworkCreationController } from './job-work-creation-controller';
import { JobworkCreationService } from './job-work-creation-service';
import { PriceNegotiationEntity } from './entity/price-negotiation-entity';
import { VendorsEntity } from '../../vendor-registration/entity/vendors.entity';
import { WhatsAppNotificationService } from '../../../../../../libs/shared-services/src/common/whatsapp-message'
import { JobworkCreationRepository } from './job-work-creation-repo';


@Module({
    imports: [TypeOrmModule.forFeature([JobworkCreationEntity, PriceNegotiationEntity, VendorsEntity, JobworkCreationRepository])],
    controllers: [JobworkCreationController],
    providers: [JobworkCreationService,WhatsAppNotificationService, ApplicationExceptionHandler],
})
export class JobworkCreationModule {}
